import { Image } from '@cian/ui-kit';
import { IconPlaceholderImage16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import styles from './CardImage.css';
import { IHeaderCard } from '../../../../../types/chatHeader';

export const CardImage: React.FC<IHeaderCard['image']> = ({ type, url }) => {
  if (type === 'remote' && url) {
    return <Image width={40} height={40} objectFit="cover" src={url} data-testid="image" />;
  }

  if (type === 'placeholder') {
    return (
      <div className={styles['empty']} data-testid="empty_image">
        <IconPlaceholderImage16 color="current_color" />
      </div>
    );
  }

  return null;
};
